import {MapConfigData} from './map-editor.component';
import { QGraph, QGraphVertex, QGraphVertexWithCircle, QuestStepObjectiveType } from 'quest-atlas-angular-components';

export interface MapEditorExternalApi {
  isValid(): boolean;

  apply(): MapConfigData;
}


export interface MapEditorQuestObjective {
  type: QuestStepObjectiveType;
}

export interface MapEditorQuestObjectiveMarkerReach extends MapEditorQuestObjective {
  type: QuestStepObjectiveType.markerReach;
  marker?: QGraphVertex
}

export const isTypeMapEditorQuestObjectiveMarkerReach = (obj: MapEditorQuestObjective): obj is MapEditorQuestObjectiveMarkerReach => {
  return obj.type === QuestStepObjectiveType.markerReach;
}

export interface MapEditorQuestObjectiveMarkerFind extends MapEditorQuestObjective {
  type: QuestStepObjectiveType.markerFind;
  marker?: QGraphVertexWithCircle
}

export const isTypeMapEditorQuestObjectiveMarkerFind = (obj: MapEditorQuestObjective): obj is MapEditorQuestObjectiveMarkerFind => {
  return obj.type === QuestStepObjectiveType.markerFind;
}

export interface MapEditorQuestObjectiveDiscovery extends MapEditorQuestObjective {
  type: QuestStepObjectiveType.discovery;
  zone?: QGraph;
  discoveryPercent?: number;
}

export const isTypeMapEditorQuestObjectiveDiscovery = (obj: MapEditorQuestObjective): obj is MapEditorQuestObjectiveDiscovery => {
  return obj.type === QuestStepObjectiveType.discovery;
}
